// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "footer{position:relative;z-index:1}footer .section-content{padding-bottom:3rem;padding-top:3rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
